import React from "react";
import { Navbar } from "@allxsmith/bestax-bulma";

function QuickLinksNav({quickLinks}) {
  return (
    <Navbar.DropdownMenu className={"scrollable"}>
      {quickLinks.map((quickLink, index) => (
          <Navbar.Item key={index} onClick={() => window.open(`${quickLink.url}`, '_blank')}>
            {quickLink.title}
          </Navbar.Item>
      ))}
    </Navbar.DropdownMenu>
  );
}

export default QuickLinksNav;
